import { PageHeader } from "../components/common/PageHeader";
import { UploadLimitBanner } from "../components/common/UploadLimitBanner";
import { ProjectScopeBanner } from "../components/common/ProjectScopeBanner";
import { OpsWizard } from "../components/common/OpsWizard";

export default function BacklogCompletion() {
  return (
    <div>
      <PageHeader title="Backlog Material Completion" subtitle="Migrate historical materials directly to COMPLETED_DATA_ENTRY (GRN_PENDING / GRN_COMPLETED only)" />
      <UploadLimitBanner kind="backlog" />
      <ProjectScopeBanner requireProject action="backlog completion" />
      <OpsWizard
        testid="backlog"
        needsType
        templateUrl="/materials/backlog/template"
        previewUrl="/materials/backlog/preview"
        applyUrl="/materials/backlog/apply"
        statusUrlBase="/materials/backlog/apply-status"
        rejectedUrlBase="/materials/backlog/rejected"
        applyLabel={(n) => `Complete ${n} materials`}
        extraNote="This is a controlled migration utility. Only existing GRN_PENDING / GRN_COMPLETED materials are matched by serial and completed. No fake GRN/allocation/install events are created."
      />
    </div>
  );
}
